// API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const EMPRESA_NAME = process.env.REACT_APP_EMPRESA_NAME;

// API functions for SoftInm integration

export const getPropertyTypes = async () => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      console.warn('API_TOKEN or EMPRESA_NAME not configured, returning empty array');
      // Fallback to empty array if environment variables are not set
      return Promise.resolve([]);
    }

    const response = await fetch(
      `${API_BASE_URL}/inmuebles/consultar_clases_inmuebles/${EMPRESA_NAME}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.exito) {
      return result.data || [];
    } else {
      console.error('API Error:', result.mensaje);
      throw new Error(result.mensaje || 'Error desconocido en la API');
    }
  } catch (error) {
    console.error('Error fetching property types:', error);
    // Return empty array as fallback
    return [];
  }
};

export const getMunicipiosYBarrios = async () => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      console.warn('API_TOKEN or EMPRESA_NAME not configured, returning empty array');
      // Fallback to empty array if environment variables are not set
      return Promise.resolve([]);
    }

    const response = await fetch(
      `${API_BASE_URL}/inmuebles/consultar_municipios_y_barrios/${EMPRESA_NAME}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (response.ok) {
      return result || [];
    } else {
      console.error('API Error:', result.mensaje);
      throw new Error(result.mensaje || 'Error desconocido en la API');
    }
  } catch (error) {
    console.error('Error fetching locations:', error);
    // Return empty array as fallback
    return [];
  }
};

// Function to send contact form
export const enviarContacto = async (formData) => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      throw new Error('Configuración de API incompleta: TOKEN o EMPRESA_NAME no encontrados');
    }

    const response = await fetch(
      `${API_BASE_URL}/bandejadecorreos/guardar_contactenos/${EMPRESA_NAME}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.exito !== false) {
      return result;
    } else {
      throw new Error(result.mensaje || 'Error al enviar el mensaje');
    }
  } catch (error) {
    console.error('Error enviando contacto:', error);
    throw error;
  }
};

// Function to search properties
export const consultarInmuebles = async (filtros) => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      throw new Error('Configuración de API incompleta: TOKEN o EMPRESA_NAME no encontrados');
    }
    //console.log('Consultando inmuebles con filtros:', filtros);
    console.log('Consultando inmuebles con filtros:json', JSON.stringify(filtros));
    const response = await fetch(
      `${API_BASE_URL}/inmuebles/consultar_inmuebles/${EMPRESA_NAME}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filtros)
      }
    );
    //console.log("response",response);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const responseData = await response.json();

    return responseData || [];
  } catch (error) {
    console.error('Error consultando inmuebles:', error);
    throw error;
  }
};

// Function to get a specific property by code
export const consultarInmueble = async (codigo) => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      throw new Error('Configuración de API incompleta: TOKEN o EMPRESA_NAME no encontrados');
    }

    const response = await fetch(
      `${API_BASE_URL}/inmuebles/consultar_inmuebles/${EMPRESA_NAME}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ codigo })
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result && result.length > 0) {
      return result[0]; // Return the first (and should be only) result
    } else {
      throw new Error('Inmueble no encontrado');
    }
  } catch (error) {
    console.error('Error consultando inmueble:', error);
    throw error;
  }
};

//function to get featured properties
export const getFeaturedProperties = async () => {
  try {
    if (!API_TOKEN || !EMPRESA_NAME) {
      console.warn('API_TOKEN or EMPRESA_NAME not configured, returning empty array');
      // Fallback to empty array if environment variables are not set
      return Promise.resolve([]);
    }
    const response = await fetch(
      `${API_BASE_URL}/inmuebles/consultar_inmuebles/${EMPRESA_NAME}`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${API_TOKEN}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "cantidadporpagina": 10,
          "pagina": 1,
          "destacado": true
        })
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result || [];

  } catch (error) {
    console.error('Error fetching featured properties:', error);
    // Return empty array as fallback
    return [];
  }
};
